import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageScreenMiddle } from "../Page/Page";
function ErrorPage({ errorTitle, errorDescription }) {
    return (_jsxs(PageScreenMiddle, { children: [_jsx("h2", { children: errorTitle }), errorDescription && _jsx("p", { children: errorDescription })] }));
}
export { ErrorPage };
